export default [
  {
    path: '/puan',
    name: 'puan-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'Puan',
      yetki: { k: [2000202] },
    },
  },
]
